import { api } from './index'

// camelCase domain type (the API returns snake_case; we map explicitly below).
// satisfaction_rate is a fraction 0..1, or null when there are no responded
// ratings in the window. Preserved as null (never coalesced to 0) so the card
// renders an em-dash instead of fabricating "0% satisfaction".
export type OrderSatisfaction = {
  satisfactionRate: number | null
  respondedCount: number
}

type RawOrderSatisfaction = {
  satisfaction_rate: number | null
  responded_count: number
}

export const toOrderSatisfaction = (
  raw: RawOrderSatisfaction
): OrderSatisfaction => ({
  satisfactionRate: raw.satisfaction_rate,
  respondedCount: raw.responded_count,
})

// Base URL already includes /merchants/:current_merchant_id (see api/utils.ts
// buildBaseUrl), so the path is relative to the merchant scope.
export const orderSatisfactionApi = api.injectEndpoints({
  endpoints: builder => ({
    getOrderSatisfaction: builder.query<OrderSatisfaction, void>({
      query: () => 'metrics/order_satisfaction',
      transformResponse: (raw: RawOrderSatisfaction) =>
        toOrderSatisfaction(raw),
      providesTags: ['OrderSatisfaction'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetOrderSatisfactionQuery } = orderSatisfactionApi
